import api from '@/api/example/index'

async function getTermsData(cryptedTicket, token) {
  api.defaults.headers.common = { Authorization: `bearer ${token}` }

  return api.get(`/v1/term/decrypt-ticket?crypted_ticket=${cryptedTicket}`)
}

export default getTermsData
